import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_ENDPOINTS, METHOD_TYPE } from "../../utils/apiUrls";
import api from "../../utils/api";

const initialState = {
    isLoading: false,
    error: null,
    previousSearchesData: [],
    companySearchDetails: [],
    getCorporateReportDataDetails:[],
    getCompanyReportDataDetails:[]
};

export const getPreviousSearches = createAsyncThunk("company_search/getPreviousSearches", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getPreviousSearches + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCompanySearchDetails = createAsyncThunk("getCompanySearchDetails", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.getCompanySearchDetails + queryParam,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCorporateAmlReportData = createAsyncThunk("corporate_onboarding/getCorporateAmlReportData", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateAmlReportData + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCompanyReportData = createAsyncThunk("company_search/getCompanyReportData", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCompanyReportData + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

const companyCheckSlice = createSlice({
    name: "companyCheck",
    initialState,
    reducers: {
        resetCompanySearchDetails: (state) => {
            state.companySearchDetails = [];
        },
    },
    extraReducers: (builder) => {
        const handleLoading = (state, action) => {
            state.isLoading = action.meta.requestStatus === 'pending';
        };

        builder
            .addCase(getPreviousSearches.fulfilled, (state, { payload }) => {
                state.previousSearchesData = payload.data;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getPreviousSearches.rejected, (state, { payload }) => {
                state.previousSearchesData = null;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getCompanySearchDetails.fulfilled, (state, action) => {
                state.companySearchDetails = action.payload
            })
            .addCase(getCorporateAmlReportData.fulfilled, (state, { payload }) => {
                state.getCorporateReportDataDetails = payload.data;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getCompanyReportData.fulfilled, (state, { payload }) => {
                state.getCompanyReportDataDetails = payload.data;
                state.isLoading = false;
                state.error = null;
            })
            .addMatcher(
                (action) =>
                    action.type === getPreviousSearches.pending.type ||
                    action.type === getPreviousSearches.fulfilled.type ||
                    action.type === getPreviousSearches.rejected.type ||
                    action.type === getCompanySearchDetails.pending.type ||
                    action.type === getCompanySearchDetails.fulfilled.type ||
                    action.type === getCompanySearchDetails.rejected.type ||
                    action.type === getCorporateAmlReportData.pending.type ||
                    action.type === getCorporateAmlReportData.fulfilled.type ||
                    action.type === getCorporateAmlReportData.rejected.type ||
                    action.type === getCompanyReportData.pending.type ||
                    action.type === getCompanyReportData.fulfilled.type ||
                    action.type === getCompanyReportData.rejected.type,

                handleLoading
            );
    }
});

export const { resetCompanySearchDetails } = companyCheckSlice.actions;
export default companyCheckSlice.reducer;